module.exports = __webpack_public_path__ + "img/not_found.c3beb46a.png";